export const games = [
    {
        id:1,
        img: new URL("../img/games/cyberpunk.jpg", import.meta.url).href,
        // video: new URL("../videos/cyberpunk.mp4", import.meta.url).href,
        video: "https://res.cloudinary.com/dwsga3yyk/video/upload/v1766510485/cyberpunk_leuluu.mp4",
        title: "Cyberpunk 2077",
        price: 2999,
        ratings: 4.6,
        platform: ["PC","|","PS5","|","XBOX"],
        iswishlist: false,
        type: ["action","fav"],
        description:"Cyberpunk 2077 drops you into Night City, a neon-soaked world where tech upgrades your body and choices shape your legend.",
        copiessold:"Sold ~35 Million+ copies worldwide",
        store:"https://store.steampowered.com/app/1091500/Cyberpunk_2077/",
    },
    {
        id:2,
        img: new URL("../img/games/detroit.jpg", import.meta.url).href,
        video: "https://res.cloudinary.com/dwsga3yyk/video/upload/v1766513776/detroit_elvmmm.mp4",
        title: "Detroit Became Human",
        price: 2499,
        ratings: 4.8,
        platform: ["PC","|","PS5"],
        iswishlist: false,
        type: ["story", "fav"],
        description:"Detroit: Become Human explores a near future where androids question their purpose—and their humanity.",
        copiessold:"Sold ~11 Million+ copies worldwide",
        store:"https://store.steampowered.com/app/1222140/Detroit_Become_Human/",
    },
    {
        id:3,
        img: new URL("../img/games/gow-4.jpg", import.meta.url).href,
        video: "https://res.cloudinary.com/dwsga3yyk/video/upload/v1766788570/gow4_hge2nw.mp4",
        title: "God Of War 2018",
        price: 2199,
        ratings: 4.7,
        platform: ["PC","|","PS5","|","XBOX"],
        iswishlist: false,
        type: ["story"],
        description:"God of War reimagines the legend—an epic journey of gods, monsters, and a father learning to be human.",
        copiessold:"Sold ~23 Million+ copies worldwide",
        store:"https://store.steampowered.com/app/1593500/God_of_War/",
    },
    {
        id:4,
        img: new URL("../img/games/gow-5.jpg", import.meta.url).href,
        video: "https://res.cloudinary.com/dwsga3yyk/video/upload/v1766518866/gow5_l7nkbh.mp4",
        title: "God Of War Ragnarok",
        price: 2999,
        ratings: 5,
        platform: ["PC","|","PS5","|","XBOX"],
        iswishlist: false,
        type: ["story","fav"],
        description:"God of War Ragnarök follows Kratos and Atreus as they journey through the Nine Realms, facing gods, monsters, and the coming of Ragnarök.",
        copiessold:"Sold ~15 Million+ copies worldwide",
        store:"https://store.steampowered.com/app/2322010/God_of_War_Ragnark/",
    },
    {
        id:5,
        img: new URL("../img/games/gta5.jpg", import.meta.url).href,
        video: "https://res.cloudinary.com/dwsga3yyk/video/upload/v1766519575/gta5_gnhngt.mp4",
        title: "Grand Theft Auto 5",
        price: 1599,
        ratings: 4.5,
        platform: ["PC","|","PS5","|","XBOX"],
        iswishlist: false,
        type: ["story","action"],
        description:"Grand Theft Auto V follows three criminals navigating crime, chaos, and ambition in the sprawling city of Los Santos.",
        copiessold:"Sold ~220 Million+ copies worldwide",
        store:"https://store.steampowered.com/app/271590/Grand_Theft_Auto_V/",
    },
    {
        id:6,
        img: new URL("../img/games/last-of-us-1.jpg", import.meta.url).href,
        video: "https://res.cloudinary.com/dwsga3yyk/video/upload/v1766519873/last-of-us1_uziutr.mp4",
        title: "The Last Of Us Part 1",
        price: 2799,
        ratings: 4.8,
        platform: ["PC","|","PS5"],
        iswishlist: false,
        type: ["story"],
        description:"The Last of Us follows Joel and Ellie as they journey across a broken world, fighting to survive and protect what remains.",
        copiessold:"Sold ~17 Million+ copies worldwide",
        store:"https://store.steampowered.com/app/1888930/The_Last_of_Us_Part_I/",
    },
    {
        id:7,
        img: new URL("../img/games/last-of-us-2.jpg", import.meta.url).href,
        video: "https://res.cloudinary.com/dwsga3yyk/video/upload/v1766520589/last-of-us2_hu7s6m.mp4",
        title: "The Last Of Us Part 2",
        price: 2999,
        ratings: 5,
        platform: ["PC","|","PS5"],
        iswishlist: false,
        type: ["story","fav"],
        description:"Step into a world reclaimed by nature, where every shadow hides danger, every fight is a test, and your choices shape Ellie’s journey.",
        copiessold:"Sold ~10 Million+ copies worldwide",
        store:"https://store.steampowered.com/app/2531310/The_Last_of_Us_Part_II_Remastered/",
    },
    {
        id:8,
        img: new URL("../img/games/little-nightmares-2.jpg", import.meta.url).href,
        video: "https://res.cloudinary.com/dwsga3yyk/video/upload/v1766788391/little-nightmares2_xaclm7.mp4",
        title: "Little Nightmares 2",
        price: 1599,
        ratings: 4.5,
        platform: ["PC","|","PS5"],
        iswishlist: false,
        type: ["horror"],
        description:"Little Nightmares II plunges you into a creepy, twisted world where shadows hide monsters, and every corner hides a new danger.",
        copiessold:"Sold ~3 Million+ copies worldwide",
        store:"https://store.steampowered.com/app/860510/Little_Nightmares_II/",
    },
    {
        id:9,
        img: new URL("../img/games/rdr2.jpg", import.meta.url).href,
        video: "https://res.cloudinary.com/dwsga3yyk/video/upload/v1766788393/rdr2_jjqwtv.mp4",
        title: "Red Dead Redemption 2",
        price: 2999,
        ratings: 4.8,
        platform: ["PC","|","PS5","|","XBOX"],
        iswishlist: false,
        type: ["story"],
        description:"Ride across mountains, rivers, and towns, hunt, rob, and live the life of an outlaw in a breathtakingly detailed open world.",
        copiessold:"Sold ~79 Million+ copies worldwide",
        store:"https://store.steampowered.com/app/1174180/Red_Dead_Redemption_2/",
    },
    {
        id:10,
        img: new URL("../img/games/spiderman-miles.jpg", import.meta.url).href,
        video: "https://res.cloudinary.com/dwsga3yyk/video/upload/v1766788427/spiderman-miles_avi3gs.mp4",
        title: "Spider-Man Miles Morales",
        price: 2899,
        ratings: 4.7,
        platform: ["PC","|","PS5","|","XBOX"],
        iswishlist: false,
        type: ["action", "fav"],
        description:"Spider-Man: Miles Morales swings you through a vibrant, snowy New York as Miles discovers his powers and what it truly means to be a hero.",
        copiessold:"Sold ~8 Million+ copies worldwide",
        store:"https://store.steampowered.com/app/1817190/Marvels_SpiderMan_Miles_Morales/",
    },
    {
        id:11,
        img: new URL("../img/games/stray.jpg", import.meta.url).href,
        video: "https://res.cloudinary.com/dwsga3yyk/video/upload/v1766788353/stray_pjli0z.mp4",
        title: "Stray",
        price: 1299,
        ratings: 4.5,
        platform: ["PC","|","PS5","|","XBOX"],
        iswishlist: false,
        type: ["story"],
        description:"Stray lets you explore a neon-lit, futuristic city as a stray cat, solving puzzles, sneaking past dangers, and uncovering a mysterious world.",
        copiessold:"Sold ~6 Million+ copies worldwide",
        store:"https://store.steampowered.com/app/1332010/Stray/",
    },
    {
        id:12,
        img: new URL("../img/games/tomb-raider.jpg", import.meta.url).href,
        video:"https://res.cloudinary.com/dwsga3yyk/video/upload/v1766788643/rise-of-the-tomb-raider_s0lbbg.mp4",
        title: "Rise Of The Tomb Raider",
        price: 2899,
        ratings: 4.7,
        platform: ["PC","|","PS5","|","XBOX"],
        iswishlist: false,
        type: ["action", "fav"],
        description:"Explore vast landscapes, solve intricate puzzles, and master combat as Lara evolves from survivor to legend.",
        copiessold:"Sold ~10 Million+ copies worldwide",
        store:"https://store.steampowered.com/app/391220/Rise_of_the_Tomb_Raider/",
    },
];